import { CHILD_ROW, PARENT_ROW } from 'components/pages/pre-screen/PatientDatabase/constants';

export const getPatientTreePath = row => row.treePath;

export function groupRows(patientGroups) {
  return patientGroups.flatMap(createPatientWithChildrenRows);
}

function createPatientWithChildrenRows(group) {
  const { children = [], medicalHistories, medications, ...patientIdentity } = group;
  const { patientId } = patientIdentity;
  const parentFilterValues = {
    medicalHistories: medicalHistories ?? [],
    medications: medications ?? []
  };

  const parentRow = {
    ...patientIdentity,
    ...parentFilterValues,
    sourceRowId: patientId,
    id: patientId,
    patientGroupCount: children.length,
    patientRowType: PARENT_ROW,
    treePath: [patientId]
  };
  const detailRows = [...children].sort(compareByCreatedAtDescending).map(row => {
    const rowId = row.id ?? row.sitePatientId;
    return {
      ...row,
      ...patientIdentity,
      id: rowId,
      sourceRowId: rowId,
      parentFilterValues,
      patientRowType: CHILD_ROW,
      treePath: [patientId, rowId]
    };
  });

  return [parentRow, ...detailRows];
}

function compareByCreatedAtDescending(left, right) {
  const leftTimestamp = toTimestamp(left.createdAt);
  const rightTimestamp = toTimestamp(right.createdAt);

  if (leftTimestamp === rightTimestamp) {
    return 0;
  }

  return rightTimestamp - leftTimestamp;
}

const toTimestamp = date => {
  const timestamp = Date.parse(date);
  return Number.isNaN(timestamp) ? Number.NEGATIVE_INFINITY : timestamp;
};
